import { TableHead, SearchData, InputBoX } from "../../../../common/dataClass/Default"

class TransitWasehouseSearchData extends SearchData{
  constructor() {
    super()
    /**地域分类 */
    this.localSort = ''
    /**国家 */
    this.country = ''
    /**仓储分类 */
    this.sort = ''
  }
}

class TransitWarehouseTableHead extends TableHead{
  constructor(name, prop, width, obj){
    super(name, prop, width, obj)
  }
}

class TransitWasehouseInputBox extends InputBoX{
  constructor(type, name, data, obj = { isRequired: false }){
    super(type, name, data, obj)
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
  }
}

class WarehouseSort{
  constructor(data, name) {
    this.data = data
    this.name = name
  }
}

class TransitWasehouse{
  constructor() {
    /**仓库分类 */
    this.transitWasehouseSort = ''
    /**名称 */
    this.name = ''
    /**仓库简称 */
    this.abbreviation = ''
    /**仓库代码 */
    this.code = ''
    /**仓储分类 */
    this.wasrhouseSort = ''
    /**地域分类 */
    this.localSort = ''
    /**仓库面积 */
    this.area = ''
    /**仓库储位 */
    this.storage = ''
    /**联系人 */
    this.concatName = ''
    /**手机 */
    this.concatNum = ''
    /**国家 */
    this.country = ''
    /**地址 */
    this.province = ''
    this.city = ''
    this.county = ''
    this.location = ''
    /**仓库收货时间 */
    this.deliveryData = ''
    /**备注 */
    this.remark = ''
    /**创建日期 */
    this.time = ''
  }
}

class TransitWarehouseNewModule{
  static NEWTABLEHEAD(){
    let arr = [
      new TransitWarehouseTableHead('仓库ID', 'img', '80'),
      new TransitWarehouseTableHead('仓库代码', 'img', '100'),
      new TransitWarehouseTableHead('仓库简称', 'getNetProfitOfGoodsByTable', '100'),
      new TransitWarehouseTableHead('供应商名称', 'img', '100'),
      new TransitWarehouseTableHead('仓储分类', 'getNetProfitOfGoodsByTable', '100'),
      new TransitWarehouseTableHead('地域分类', 'img', '100'),
      new TransitWarehouseTableHead('仓库分类', 'getNetProfitOfGoodsByTable', '100'),
      new TransitWarehouseTableHead('储位数量', 'stockPrice', '100'),
      new TransitWarehouseTableHead('详细地址', 'getShowNumAndActualNumByTable', '150'),
      new TransitWarehouseTableHead('国家', 'getShowNumAndActualNumByTable', '150'),
      new TransitWarehouseTableHead('省州', 'getShowNumAndActualNumByTable', '150'),
      new TransitWarehouseTableHead('城市', 'stockPrice', '200'),
      new TransitWarehouseTableHead('仓库面积', 'getSavePriceByTable', '100'),
      new TransitWarehouseTableHead('仓库联系人', 'disposalNum', '120'),
      new TransitWarehouseTableHead('仓库联系方式', 'getCostSummaryByTable', '100'),
      new TransitWarehouseTableHead('仓库收货时间', 'disposalNum', '180'),
      new TransitWarehouseTableHead('备注', 'disposalNum', '150'),
      new TransitWarehouseTableHead('更新日期', 'getCostSummaryByTable', '100'),
      new TransitWarehouseTableHead('操作', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
  /**仓库分类 */
  static NEWSORTARRAY(){
    let arr = [
      new WarehouseSort('supplier', '供应商仓库'),
      new WarehouseSort('self', '自己仓库'),
      new WarehouseSort('other', '其他中转仓(包括：国内中转仓,海外中转仓,但不包括亚马逊仓)')
    ]
    return arr
  }
  /**左侧输入框 */
  static NEWLEFTINPUTMODULE(){
    let obj = {
      name: new TransitWasehouseInputBox('select', '供应商名称', 'name', { isRequired: true, pla: '20字以内' }),
      abbreviation: new TransitWasehouseInputBox('input', '仓库简称', 'abbreviation', { isRequired: true, pla: '20字以内' }),
      code: new TransitWasehouseInputBox('input', '仓库代码', 'code', { isRequired: true, pla: '20字以内,无代码可不输入' }),
      wasrhouseSort: new TransitWasehouseInputBox('select', '仓储分类', 'wasrhouseSort', { isRequired: true, pla: '' }),
      localSort: new TransitWasehouseInputBox('select', '地域分类', 'localSort', { isRequired: true, pla: '请选择分类' }),
      area: new TransitWasehouseInputBox('input', '仓库面积', 'area', { isRequired: false, pla: '20字以内,无代码可不输入' }),
      storage: new TransitWasehouseInputBox('input', '仓库储位', 'storage', { isRequired: false, pla: '' })
    }
    return obj
  }
  /**右侧输入框 */
  static NEWRIGHTINPUTMODULE(){
    let obj = {
      concatName: new TransitWasehouseInputBox('input', '仓库联系人', 'name', { isRequired: true, pla: '20字以内,无代码可不输入' }),
      concatNum: new TransitWasehouseInputBox('input', '手机', 'abbreviation', { isRequired: true, pla: '20字以内,无代码可不输入' }),
      country: new TransitWasehouseInputBox('select', '国家', 'code', { isRequired: true, pla: '' }),
      province: new TransitWasehouseInputBox('select', '省/州', 'wasrhouseSort', { isRequired: true, pla: '省/州' }),
      city: new TransitWasehouseInputBox('select', '城市', 'localSort', { isRequired: true, pla: '城市' }),
      county: new TransitWasehouseInputBox('select', '区', 'area', { isRequired: true, pla: '区' }),
      location: new TransitWasehouseInputBox('input', '详细地址', 'storage', { isRequired: true, pla: '请填写仓库详细地址' }),
      deliveryData: new TransitWasehouseInputBox('input', '仓库收货时间', 'storage', { isRequired: true, pla: '例如: 周一至周六, 8:30~18:00 (节假日除外)' })
    }
    return obj
  }
}

export{
  TransitWasehouseSearchData, TransitWarehouseNewModule, TransitWasehouse
}
